import logger from "redux-logger";
import { configureStore } from "@reduxjs/toolkit";

import QuestionTableReducer from "@learningblocks/simulations/shared-components/lib/Questions/QuestionTableRedux/store/reducer";
import { tableQuestionReducer } from "@labxchange/ui-components/lib/TableQuestion/TableQuestionSlice";
import {
  singleSelectReducer,
  multiSelectReducer,
  questionActionTranslator,
} from "@labxchange/ui-components";

export const Store = configureStore({
  reducer: {
    questionTable: QuestionTableReducer,
    tableQuestion: tableQuestionReducer,
    cscq: singleSelectReducer,
    mscq: multiSelectReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }).concat(questionActionTranslator, logger),
});
